<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Login History
          </v-card-title>
          <v-divider/>
          <v-data-table
              :headers="headers"
              :items="loginHistory"
              :footer-props="{
              'items-per-page-options':[15],
              'disable-items-per-page': true,
            }"
          >
            <template v-slot:item.status="{ item }">
              <v-chip label outlined
                      :color="item.status.value === 'SUCCESS' ? 'success' : 'error'">
                {{ item.status.description }}
              </v-chip>
            </template>
            <template #footer.prepend>
              <v-spacer/>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Home",
  data: () => ({
    loginHistory: [],
    googleAuthDialog: false,
    googleAuthInfo: {},
    showGoogleAuthSecret: false,
    e6: 1,
    headers: [
      {text: 'ID', value: 'id', sortable: false},
      {text: 'time', value: 'cdt', sortable: false},
      {text: 'ip', value: 'ip', sortable: false},
      // {text: 'browser', value: 'browser', sortable: false},
      // {text: 'os', value: 'os', sortable: false},
      {text: 'status', value: 'status', sortable: false},
    ],
  }),
  methods: {
  },
  created() {
    this.$http.get("/login/history")
        .then(
            r => this.loginHistory = r.data,
            e => this.setGlobalErrorMessage(e)
        )
  },
  computed: {
    ...mapGetters(["user"])
  }
}
</script>

<style scoped>

</style>